import React from 'react';
import { AppBar, TitlePortal } from 'react-admin';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export const MyAppBar = (props) => (
  <AppBar {...props}>
    <Box display="flex" alignItems="center" flex={1}>
      {/* এইখানে তোমার নিজের লোগো ইমেজ বসাতে পারো: */}
      {/* <img src="/logo192.png" alt="Logo" style={{ height: 32, marginRight: 10 }} /> */}
      <Typography variant="h6" color="inherit" fontWeight="bold">
        🎮 MyGame Admin
      </Typography>
    </Box>
    <TitlePortal />
  </AppBar>
);